import React, { useState, useCallback } from "react";
import { Link } from "../../utils/customLink";
import VideoCard from "../cards/videoCard";

export const AboutUsTeam = ({
  genAboutUsTeamTitle,
  genAboutUsTeamSubtitle,
  genAboutUsTeamContent,
  teamMembers,
  bgImage
}) => {
  const [visibleCnt, setVisibleCnt] = useState(3);

  const handlePagination = useCallback(() => {
    setVisibleCnt((prevState) => prevState + 3);
  }, []);

  return (
    <section className="flex justify-center pt-10 pb-0 md:pt-20 md:pb-5 bg-yellow-lighter planet:bg-gray-darker">
      <div className="w-11/12 md:w-5/6 pb-4 md:pb-0 md:px-7">
        <h1 className="pb-4 md:pb-0 font-normal planet:font-semibold planet:font-light">
          {genAboutUsTeamTitle}
        </h1>
        <h2 className="pb-4 font-light">{genAboutUsTeamSubtitle}</h2>
        <div
          className="w-full md:w-2/3 pb-10 text-black-lighter planet:text-gray-generic"
          dangerouslySetInnerHTML={{ __html: genAboutUsTeamContent }}
        />
        <div className="flex flex-wrap pb-6 md:pb-16 gap-6 w-full">
          {teamMembers.slice(0, visibleCnt)?.map((member, index) => {
            const title = member.title;
            const featuredImage = member.featuredImage?.node;
            const sourceFallbackImage = member.featuredImage?.node?.sourceUrl;
            const memberTitle = member?.teamMembersFields?.teamPosition ?? "";
            const memberVideo = member?.teamMembersFields?.memberVideo ?? "";

            return (
              <VideoCard
                key={index}
                sourceUrl={sourceFallbackImage}
                title={title}
                bgImage={featuredImage}
                memberTitle={memberTitle}
                featVideos={memberVideo}
                cardClass="rounded-xs bg-white planet:bg-gray-standard h-full w-full sm:w-[31%]"
              />
            );
          })}
        </div>
        {teamMembers.length >= visibleCnt && (
          <Link
            className="submit-button group flex justify-center items-center w-full sm:w-1/4 py-2 px-16 mx-auto"
            to={"/about-us/meet-the-team/"}
          >
            {genAboutUsTeamTitle}
          </Link>
        )}
      </div>
    </section>
  );
};
